import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMant from '../../../../../components/extras/SidePanelMant';
import MPModal from '../../../../../components/MPModal';
import TableManttos from '../../../../../components/tables/tableMantto';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemNote } from '../../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';




export const CMANotesListPage = () => {

    const { menu, parameters } = useGlobalState();


    const [notes, setNotes] = useState<ItemNote[]>([]);
    const [note, setNote] = useState<ItemNote>();
    const [detailPanel, setDetailPanel] = useState(false);
    const [filteringText, setFilteringText] = useState("");
    const mountedRef = useRef(false);



    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                if (!mountedRef.current) {
                    mountedRef.current = true;
                    handleGetNotes()
                }
                setNote(undefined)
                handleGetNote(parseInt(id))
            } else {
                setNote(undefined)
                handleGetNotes();
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleGetNote = async (idMaintenance: Number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/mants/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idMaintenance: idMaintenance,
                    read: true,
                    images: true,
                    logs: true
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.note) {
                setNote(data.note)
                setDetailPanel(true)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleGetNotes = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                timeout: 60000,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/mants/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    month: parameters.period.split("-")[1],
                    year: parameters.period.split("-")[0],
                    images: true,
                    orderBy: "dateSubmited",
                    order: "desc"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.notes) {
                setNotes(data.notes)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredRecords = notes.filter(note => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        return searchWords.every(word =>
            note.keyw.toLowerCase().includes(word) ||
            note.registration.toLowerCase().includes(word)
        );
    });

    useEffect(() => {
        if (parameters?.period !== "") {
            handleGetNotes()
        }
    }, [parameters?.period]);
    return (
        <CustomAppLayout
            toolsHide={true}
            splitPanelOpen={!!note}
            onSplitPanelToggle={({ detail }) => detail.open ? null : window.location.hash = "cma/notes/list"}
            splitPanel={
                <SidePanelMant note={note ?? {}}
                />
            }
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">

                    <Header variant="h1" actions={
                        <>
                            <Favorites />
                        </>

                    }>Notas {notes && notes.length > 0 ? " (" + notes.length + ")" : ""}</Header>
                    <SpaceBetween direction="horizontal" size="xs">
                        <FormField
                            label="Periodo de consulta">
                            <div style={{ width: 130 }}>
                                <MPModal
                                    width={120}
                                    today prevMonth nextMonth
                                    end={new Date()}
                                    date={`${parameters.period}`}
                                    onConfirm={(date) => {
                                        setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                    }}
                                />
                            </div>
                        </FormField>
                    </SpaceBetween>
                    <TableManttos notes={notes} hidePaging onSelect={(item: ItemNote) => window.location.hash = `#cma/notes/list?id=${item.idMaintenance}`} />
                </SpaceBetween>
            }
        />
    );
};


